export type PointRewardType = "discount_code" | "physical_item" | "priority_access" | "experience";

export interface PointReward {
  id: number;
  tenantId: string;
  title: string;
  description: string | null;
  pointsCost: number;
  rewardType: PointRewardType;
  /** null = ilimitado; 0 = agotado. */
  stock: number | null;
  imageUrl: string | null;
  /** Partner de Beneficios del mismo tenant; null = sin partner. */
  partnerId: string | null;
  /** Nombre actual del partner (lo resuelve el backend). Solo lectura. */
  partnerName: string | null;
  partnerLocationInfo: string | null;
  qrExpirationHours: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  pendingRedemptionCount: number;
}

export type PointRewardEditableField =
  | "title" | "description" | "pointsCost" | "rewardType" | "stock" | "imageUrl"
  | "partnerId" | "partnerLocationInfo" | "qrExpirationHours" | "active";

/** Solo lo que cambia. Cada key presente (≠ undefined) viaja; null vacía el campo. */
export type PointRewardChanges = Partial<Pick<PointReward, PointRewardEditableField>>;

export interface UpdatePointRewardPayload { id: number; changes: PointRewardChanges; }

export interface CreatePointRewardPayload extends PointRewardChanges {
  tenantId: string;
  title: string;
  pointsCost: number;
  rewardType: PointRewardType;
}

export const MIN_POINT_REWARD_COST = 1;
export const MAX_POINT_REWARD_COST = 10000;
export const MIN_QR_EXPIRATION_HOURS = 1;
export const MAX_QR_EXPIRATION_HOURS = 720;
export const DEFAULT_QR_EXPIRATION_HOURS = 72;
export const MIN_ACTIVE_REWARDS_FOR_ROLLOUT = 3;

export const POINT_REWARD_TYPE_LABELS: Record<PointRewardType, string> = {
  discount_code: "Código de descuento",
  physical_item: "Producto físico",
  priority_access: "Acceso prioritario",
  experience: "Experiencia",
};

export const formatPointRewardCost = (pointsCost: number): string =>
  `${pointsCost} ${pointsCost === 1 ? "punto" : "puntos"}`;

export const formatPointRewardStock = (stock: number | null): string => {
  if (stock === null) {
    return "Ilimitado";
  }
  return stock === 0 ? "Agotado" : `${stock}`;
};

export const countActivePointRewards = (rewards: PointReward[]): number =>
  rewards.filter((reward) => reward.active).length;

/**
 * Aviso al desactivar: los QR ya emitidos siguen valiendo hasta vencer. Lo usan el modal de baja
 * y el switch "Activo" del modal de edición, para que las dos formas de apagar avisen igual.
 */
export const formatPendingRedemptionsNotice = (count: number): string =>
  count === 1
    ? "Hay 1 canje pendiente: sigue siendo válido hasta que venza."
    : `Hay ${count} canjes pendientes: siguen siendo válidos hasta que venzan.`;
